import React, { useEffect } from 'react';
import AuthenticationService from '../../securityUtils/AuthenticationService';
import LoadingIndicator from '../Reusable/LoadingIndicator';

const SigninPage = () => {
  const signInHandler = () => {
    AuthenticationService.login();
  };
  useEffect(() => {
    signInHandler();
  }, []);
  return <LoadingIndicator />;
};

export default SigninPage;
